module.exports = __webpack_public_path__ + "img/dkb_logo_large.54bb8e8e.jpg";